import FeedbackForm from './FeedbackForm.jsx';

export {
  FeedbackForm
};



// WEBPACK FOOTER //
// ./components/feedback-form/index.js